import React, { useState, useEffect } from "react";
import userIcon from "../../Assets/Icons/show.png";
import pwdIcon2 from "../../Assets/Icons/unshow.png";
import "./UsernameInputStyles.scss";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const UsernameInput = (props) => {
  const [showPwd, setShowPwd] = useState(false);

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
        <div className="UsernameInput">
          <div className="input-container">
            <input
              type={showPwd ? "text" : props.type}
              className="input-wrapper"
              name={props.name}
              id="fname"
              placeholder={props.placeholder}
              onChange={props.onChange}
              value={props.value}
              onFocus={() => {
                props.onFocus();
              }}
              onBlur={() => {
                props.onBlur();
              }}
              onPaste={props.onPaste}
            />

            <div className="icon-container">
              {props.name === "password" ? (
                <span
                  for="fname"
                  className="icon"
                  onClick={() => {
                    if (showPwd) {
                      setShowPwd(false);
                    } else {
                      setShowPwd(true);
                    }
                  }}
                >
                  {showPwd ? (
                    <img src={pwdIcon2} alt=""  className="icon"/>
                  ) : (
                    <img src={userIcon} alt=""  className="icon"/>
                  )}
                </span>
              ) : (
                ""
              )}

              {props.name === "confirmPass" ? (
                <span
                  for="fname"
                  className="icon"
                  onClick={() => {
                    if (showPwd) {
                      setShowPwd(false);
                    } else {
                      setShowPwd(true);
                    }
                  }}
                >
                  {showPwd ? (
                    <img src={pwdIcon2} alt="" />
                  ) : (
                    <img src={userIcon} alt="" />
                  )}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
  );
};

export default UsernameInput;
